module.exports = "<app-terms-heading></app-terms-heading>\n<app-footer></app-footer>"